<template>
    <div class="tw-ws-clock" :style="{position: 'absolute', fontSize: `${fontSize}px`, color: fontColor}">
        <div class="tw-ws-clock-week" v-if="format === '日期+时分+星期'">
            <div class="tw-ws-clock-week-left" :style="{fontSize: `${fontSize + 13}px`}">{{hour}}:{{minute}}</div>
            <div class="tw-ws-clock-week-right" :style="{fontSize: `${fontSize/2 + 4}px`}">
                <div>{{year}}-{{month}}-{{day}}</div>
                <div>{{week}}</div>
            </div>
        </div>
        <span v-else-if="format === '日期+时分秒'">{{year}}-{{month}}-{{day}} {{hour}}:{{minute}}:{{second}}</span>
        <span v-else-if="format === '日期+时分'">{{year}}-{{month}}-{{day}} {{hour}}:{{minute}}</span>
        <span v-else-if="format === '日期'">{{year}}-{{month}}-{{day}}</span>
        <span v-else-if="format === '时分'">{{hour}}:{{minute}}</span>
        <span v-else-if="format === '时分秒'">{{hour}}:{{minute}}:{{second}}</span>
    </div>
</template>
<script>
import { onMounted, onUnmounted, ref } from 'vue'

export default {
    name: 'tw-ws-clock',

    setup(){
        let timer = ref(null)
        let hour = ref('00');
        let minute = ref('00');
        let second = ref('00');
        let year = ref('0000');
        let month = ref('00');
        let day = ref('00');
        let week = ref('星期');

        onMounted(() => {
            timer = setInterval(()=>{
                getTime()
            },1000);
        })

        onUnmounted(() => {
            clearInterval(timer);
        })

        const getTime = (() => {
            let now = new Date(),
            _hour = now.getHours(),
            _minute = now.getMinutes(),
            _second = now.getSeconds(),
            _year = now.getFullYear(),
            _month = now.getMonth()+1,
            _day = now.getDate(),
            _week = now.getDay(),
            _weeks = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];

            
            hour.value = _hour<10 ? '0'+_hour : _hour;
            minute.value = _minute<10 ? '0'+_minute : _minute;
            second.value = _second<10 ? '0'+_second : _second;
            year.value = _year;
            month.value = _month<10 ? '0'+_month : _month;
            day.value = _day<10 ? '0'+_day : _day;
            week.value = _weeks[_week];
        })


        return{
            hour,
            minute,
            second,
            year,
            month,
            day,
            week
        }
    },

    props: {
        fontSize: {
            type: Number,
            default: 25
        },
        fontColor: {
            type: String,
            default: '#FFFFFF'
        },
        format: {
            type: String,
            default: '日期+时分+星期'
        }
    }
}
</script>
<style lang="scss" scoped>

</style>